const apiPaths = {
  token: "/token/",
  self: "/users/self/",
  users: "/users",
  stations: "/dock-stations",
  vehicles: "/vehicles",
  batteries: "/batteries",
  rides: "/rides",
  transactions: "/transactions",
  stats: "/dashboard",
  constants: "/constants",
};

export default apiPaths;
